export default {
  lookups: state => state.lookups,
  groups: state => state.groups,
  timeZones: state => state.timeZones,
  countries: state => state.countries,
  stateProvinces: state => state.stateProvinces,
  languages: state => state.languages,
  calibrateReady: state => state.calibrateReady,
  calibratePreCheckList: state => state.calibratePreCheckList,
  calibrateService: state => state.calibrateService,
  calibrateActionType: state => state.calibrateActionType,
  calibrateVerify: state => state.calibrateVerify,
  centerFirms: state => state.centerFirms,
  brand: state => state.brand,
  newInsurance: state => state.newInsurance,
  search: state => state.search,
  selectedInsurance: state => state.selectedInsurance,
  insuranceLookup: state => state.insuranceLookup,
  sourceInsurance: state => state.sourceInsurance,
  insurance: state => state.insurance,
  pricingRules: state => state.pricingRules
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/getters.js